// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file storage.proto (package sextante.storage.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file storage.proto.
 */
export const file_storage: GenFile = /*@__PURE__*/
  fileDesc("Cg1zdG9yYWdlLnByb3RvEhNzZXh0YW50ZS5zdG9yYWdlLnYxIisKFkdldFNhc1VwbG9hZFVybFJlcXVlc3QSEQoJZmlsZV9uYW1lGAEgASgJIjUKEFNhc1VwbG9hZFVybEl0ZW0SDwoHc2FzX3VybBgBIAEoCRIQCghibG9iX3VybBgCIAEoCSIYChZHZXRUaWxlc1Nhc1JlYWRSZXF1ZXN0IjcKDlNhc1JlYWRVcmxJdGVtEhEKCXNhc190b2tlbhgBIAEoCRISCgpleHBpcmVzX29uGAIgASgJMtwBCg5TdG9yYWdlU2VydmljZRJlCg9HZXRTYXNVcGxvYWRVcmwSKy5zZXh0YW50ZS5zdG9yYWdlLnYxLkdldFNhc1VwbG9hZFVybFJlcXVlc3QaJS5zZXh0YW50ZS5zdG9yYWdlLnYxLlNhc1VwbG9hZFVybEl0ZW0SYwoPR2V0VGlsZXNTYXNSZWFkEisuc2V4dGFudGUuc3RvcmFnZS52MS5HZXRUaWxlc1Nhc1JlYWRSZXF1ZXN0GiMuc2V4dGFudGUuc3RvcmFnZS52MS5TYXNSZWFkVXJsSXRlbUILqgIIQXBpLkdycGNiBnByb3RvMw");

/**
 * Archivo a subir.
 *
 * @generated from message sextante.storage.v1.GetSasUploadUrlRequest
 */
export type GetSasUploadUrlRequest = Message<"sextante.storage.v1.GetSasUploadUrlRequest"> & {
  /**
   * Nombre del archivo. Se usa solo el nombre, sin carpetas.
   *
   * @generated from field: string file_name = 1;
   */
  fileName: string;
};

/**
 * Describes the message sextante.storage.v1.GetSasUploadUrlRequest.
 * Use `create(GetSasUploadUrlRequestSchema)` to create a new message.
 */
export const GetSasUploadUrlRequestSchema: GenMessage<GetSasUploadUrlRequest> = /*@__PURE__*/
  messageDesc(file_storage, 0);

/**
 * Donde subir el archivo y donde va a quedar.
 *
 * @generated from message sextante.storage.v1.SasUploadUrlItem
 */
export type SasUploadUrlItem = Message<"sextante.storage.v1.SasUploadUrlItem"> & {
  /**
   * URL firmada para subir el archivo con un PUT.
   *
   * @generated from field: string sas_url = 1;
   */
  sasUrl: string;

  /**
   * URL del archivo ya subido, sin firma. Es la que se manda despues, por ejemplo en vuelo_url o blob_url.
   *
   * @generated from field: string blob_url = 2;
   */
  blobUrl: string;
};

/**
 * Describes the message sextante.storage.v1.SasUploadUrlItem.
 * Use `create(SasUploadUrlItemSchema)` to create a new message.
 */
export const SasUploadUrlItemSchema: GenMessage<SasUploadUrlItem> = /*@__PURE__*/
  messageDesc(file_storage, 1);

/**
 * Sin datos.
 *
 * @generated from message sextante.storage.v1.GetTilesSasReadRequest
 */
export type GetTilesSasReadRequest = Message<"sextante.storage.v1.GetTilesSasReadRequest"> & {
};

/**
 * Describes the message sextante.storage.v1.GetTilesSasReadRequest.
 * Use `create(GetTilesSasReadRequestSchema)` to create a new message.
 */
export const GetTilesSasReadRequestSchema: GenMessage<GetTilesSasReadRequest> = /*@__PURE__*/
  messageDesc(file_storage, 2);

/**
 * Token de lectura y su vencimiento.
 *
 * @generated from message sextante.storage.v1.SasReadUrlItem
 */
export type SasReadUrlItem = Message<"sextante.storage.v1.SasReadUrlItem"> & {
  /**
   * Token SAS que se agrega a las URL de lectura.
   *
   * @generated from field: string sas_token = 1;
   */
  sasToken: string;

  /**
   * ISO-8601 (DateTimeOffset.ToString("o")), UTC
   *
   * @generated from field: string expires_on = 2;
   */
  expiresOn: string;
};

/**
 * Describes the message sextante.storage.v1.SasReadUrlItem.
 * Use `create(SasReadUrlItemSchema)` to create a new message.
 */
export const SasReadUrlItemSchema: GenMessage<SasReadUrlItem> = /*@__PURE__*/
  messageDesc(file_storage, 3);

/**
 * Acceso de la SPA Cliente a Azure Blob Storage con URL firmadas (SAS). Usa el servicio de Storage
 * compartido con los workers, no la capa vieja de servicios. Requiere sesion de la app Cliente.
 * 
 * Solo dos de los tres endpoints REST: GetSasUploadUrl (subida) y GetTilesSasRead (lectura, 24h,
 * cuenta completa). "tiles/conteo-sas-read" (7 dias, contenedor "conteos" acotado) no tiene ningun
 * consumidor en el Cliente web -es para AgroMonitor, ver GuiaDocumentTransformer/StorageController-,
 * asi que se queda solo en REST.
 *
 * @generated from service sextante.storage.v1.StorageService
 */
export const StorageService: GenService<{
  /**
   * URL firmada para que la app suba un archivo directo a Storage, valida por 2 horas. El archivo queda en
   * una carpeta nueva con su nombre original.
   *
   * @generated from rpc sextante.storage.v1.StorageService.GetSasUploadUrl
   */
  getSasUploadUrl: {
    methodKind: "unary";
    input: typeof GetSasUploadUrlRequestSchema;
    output: typeof SasUploadUrlItemSchema;
  },
  /**
   * Token SAS de lectura de toda la cuenta de Storage, valido por 24 horas, para leer tiles e imagenes.
   *
   * @generated from rpc sextante.storage.v1.StorageService.GetTilesSasRead
   */
  getTilesSasRead: {
    methodKind: "unary";
    input: typeof GetTilesSasReadRequestSchema;
    output: typeof SasReadUrlItemSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_storage, 0);

